// extracted by mini-css-extract-plugin
export default {"listItemContainer":"ConsentList_listItemContainer__BhZFw"};